module.exports = __WEBPACK_EXTERNAL_MODULE_87__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 87
// module chunks = 0